module.exports = __webpack_public_path__ + "img/operator6_modal.7731cd4f.png";